import React from 'react'
import cn from 'classnames'
import cg from 'Scss/app.scss'
import prnt from 'Components/Profile/ProfileNavListItem/ProfileNavListItem.scss'

const Badge: React.FunctionComponent<{ label: string}> = ({ label }) =>
    <span className={cn(cg.cell, cg.shrink, prnt.cell, prnt.shrink, prnt.listItem__badge)}>
        {label}
    </span>

export default Badge
